import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'

import { AnswerType } from 'app/modules/playbook/constants'
import { weakUuid } from 'app/modules/playbook/helpers'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookModels from 'app/modules/playbook/models'

import StandardAnswerBody from './component'

const mapStateToProps = state => {
  const question = PlaybookSelectors.getCurrentQuestionByAnswer(state)
  return {
    answer: PlaybookSelectors.getCurrentAnswer(state),
    question,
    hasSpecialKeyword: PlaybookSelectors.getCurrentAnswerHasSpecialKeyword(state),
    skipToOptions: PlaybookSelectors.skipToOptions(state),
    currentSkipToOption: PlaybookSelectors.currentSkipToOption(state),
    buttonOnlyResponses: PlaybookSelectors.buttonOnlyResponses(state, question.id),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      hideAnswerModal: PlaybookActions.hideAnswerModal,
      setAnswerType: PlaybookActions.setAnswerType,
      setButtonText: PlaybookActions.setButtonText,
      addKeyword: PlaybookActions.addKeyword,
      setResponse: PlaybookActions.setResponse,
      flagAnswer: PlaybookActions.flagAnswer,
      setSkipTo: PlaybookActions.setSkipTo,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => ({
    isKeywords: props.answer.type === AnswerType.KEYWORDS,
    isFlagged: props.answer.id === props.question.defaultAnswerId,
  })),
  withHandlers({
    onCloseClick: props => () => {
      const { actions: { hideAnswerModal }} = props
      hideAnswerModal()
    },
    onButtonTextChange: props => event => {
      const { actions: { setButtonText }, answer: { id: answerId }} = props
      setButtonText({ answerId, buttonText: event.target.value })
    },
    onClickKeywordsType: props => () => {
      const { actions: { setAnswerType }, answer: { id: answerId }} = props
      setAnswerType({ answerId, type: AnswerType.KEYWORDS })
    },
    onClickButtonType: props => () => {
      const { actions: { setAnswerType }, answer: { id: answerId }} = props
      setAnswerType({ answerId, type: AnswerType.BUTTON })
    },
    onAddYesKeywordClick: props => () => {
      const { actions: { addKeyword }, answer: { id: answerId }} = props
      addKeyword({
        answerId,
        keyword: PlaybookModels.Keyword({ id: weakUuid(), special: true, text: 'Yes' }),
      })
    },
    onAddNoKeywordClick: props => () => {
      const { actions: { addKeyword }, answer: { id: answerId }} = props
      addKeyword({
        answerId,
        keyword: PlaybookModels.Keyword({ id: weakUuid(), special: true, text: 'No' }),
      })
    },
    onAddGenericKeywordClick: props => () => {
      const { actions: { addKeyword }, answer: { id: answerId }} = props
      addKeyword({
        answerId,
        keyword: PlaybookModels.Keyword({ id: weakUuid() }),
      })
    },
    onFlagClick: props => () => {
      const {
        isFlagged,
        actions: { flagAnswer },
        answer: { id: answerId },
        question: { id: questionId },
      } = props
      flagAnswer({ questionId, answerId: isFlagged ? null : answerId })
    },
    onSkipToChange: props => value => {
      const { actions: { setSkipTo }, answer: { id: answerId }} = props
      const { isGoal = false, id: skipToId = null } = value ? value.value : {}
      setSkipTo({ answerId, isGoal, skipToId })
    },
  })
)(StandardAnswerBody)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalStandardBody/index.js